export default __webpack_public_path__ + "static/media/RightManger.76e786d5.png";